import $ from 'jquery';
import {breakpointUp, breakpointDown} from './Breakpoints';
import ScrollMagicGE from './ScrollMagicGE';
import RichMenu from './RichMenu';

let Responsive = {

    init() {
        this.searchForm();
        this.menuToggle();
        this.singleCruiseSectionToggle();
        this.menuMagazineToggle();
        this.shipPortraitHeightFixer();
    },

    searchForm() {
        $(window).bind('resizeEndThrottle', () => {

            this.updateSearchFormPosition();

        });

    },
    updateSearchFormPosition() {
        if (breakpointDown('md')) {
            $("#form-search input").attr('placeholder', "Recherche");
            $("#form-search").prependTo(".wrap-mobile");
        } else {
            $("#form-search input").removeAttr('placeholder');
            $("#form-search").prependTo("#search-panel");
            $(".cta-for-mobile").appendTo(".top-header");
        }
    },
    menuToggle() {
        $('.toggle-mobile').on('click', function (event) {

            event.preventDefault();

            if ($(this).find('input').prop("checked")) {
                // On ferme le menu
                $('html').removeClass('no-scroll');
                $(this).find('input').prop("checked", false);
                $('.wrap-mobile').slideUp(400);


                setTimeout(function () {
                    $(".cta-for-mobile").appendTo(".top-header").hide().fadeIn(200);
                }, 400);

                if (ScrollMagicGE.scrollPos <= ScrollMagicGE.menuOffsetPos) {
                    $('.wrap-nav-bar').removeClass('switch');
                } else {
                    $('.nav-bar .logoGE').removeClass('show');
                }

            } else {
                // On ouvre le menu
                $('html').addClass('no-scroll');
                Responsive.updateSearchFormPosition();
                $(this).find('input').prop("checked", true);
                $(".cta-for-mobile").appendTo(".wrap-mobile");
                $('.wrap-mobile').slideDown(400);
                $('.wrap-nav-bar').addClass('switch');
                $('.nav-bar .logoGE').addClass('show');
            }

        });


    },
    menuMagazineToggle() {
        let menuOpen = false;

        $('.wrap-magazine-menu .logo').on('click', function (event) {

            if (breakpointDown('md') && !menuOpen) {
                event.preventDefault();
                $('html').addClass('no-scroll');
                $('.wrap-magazine-menu').addClass('open');
                $('#menu-menu-magazine').css('display', 'flex').hide().slideDown(200);
                menuOpen = true;
                RichMenu.showBgOverlay('modal');
                $('.wrap-nav-bar, .top-header').css('z-index', '1050');
            } else if (breakpointDown('md') && menuOpen) {
                event.preventDefault();
                $('html').removeClass('no-scroll');
                $('.wrap-magazine-menu').removeClass('open');
                $('#menu-menu-magazine').slideUp(200);
                menuOpen = false;
                RichMenu.hideBgOverlay('modal');
                setTimeout(function () {
                    $('.wrap-nav-bar, .top-header').css('z-index', '666');
                }, 300);
            }
        });

        $(window).bind('resizeEndThrottle', () => {
            if (breakpointUp('lg')) {
                $('html').removeClass('no-scroll');
                $('#menu-menu-magazine').show();
                menuOpen = false;
                $('.wrap-nav-bar, .top-header').css('z-index', '666');
                RichMenu.hideBgOverlay('modal');
            } else {
                $('html').removeClass('no-scroll');
                $('#menu-menu-magazine').hide();
                menuOpen = false;
                $('.wrap-nav-bar, .top-header').css('z-index', '666');
                RichMenu.hideBgOverlay('modal');

            }


        });

    },
    singleCruiseSectionToggle() {

        if ($('body').hasClass('single-cruise')) {

            $('.toggle-section-mobile').on('click', function (event) {
                if (breakpointDown('md')) {
                    event.preventDefault();
                    if (!$(this).hasClass('open')) {
                        $(this).addClass('open');
                        $(this).parent().find('.toggle-content').slideDown(400);
                    } else {
                        $(this).removeClass('open');
                        $(this).parent().find('.toggle-content').slideUp(400);
                    }
                }

            });


            $(window).bind('resizeEndThrottle', () => {
                if (breakpointDown('md')) {
                    $('.toggle-content').slideUp(400);
                    $('.toggle-section-mobile').removeClass('open');
                } else {
                    $('.toggle-content').slideDown(400);
                    $('.toggle-section-mobile').addClass('open');
                }


            });


        }

    },
    shipPortraitHeightFixer() {
        function updateSize() {
            let descSize = $('section.header-portrait .description').outerHeight();
            let imgSize = $('section.header-portrait .photo-portrait img').outerHeight();
            let goodSize = descSize <= imgSize ? imgSize : descSize;

            $('section.header-portrait .wrapper').css('height', goodSize);
        }


        if ($('body').hasClass('single-ship') && breakpointUp('lg')) {
            updateSize();
        }

        $(window).bind('resizeEndThrottle', () => {
            if (breakpointDown('md')) {
                $('section.header-portrait .wrapper').removeAttr("style");
            } else {
                updateSize();
            }


        });


    }

};

export default Responsive;





// WEBPACK FOOTER //
// ./assets/js/libs/Responsive.js